<div class="item-grid-container shadow">
  <div class="realtime-transactions-holder">
    <div class="search-holder">
      <ul class="list-inline mb-3 mb-sm-5">
        <li class="list-inline-item ">
          <div class="search-holder">
            <input
              type="text"
              placeholder="{{ 'pages.newRetailer.search' | translate }}"
              matInput
              class="
                rounded-pill
                px-3
                py-2
                mb-0
                border-0
                bg-light
                w-100
                me-0
                input-search
                ms-3
              "
              (keyup)="quickSearch()"
              [(ngModel)]="searchValue"
            />
            <i
              color="primary"
              class="search-icon-holder"
              matSuffix
              mat-icon-button
              aria-label="Search"
            >
              <mat-icon>search</mat-icon>
            </i>
          </div>
        </li>
        <li class="list-inline-item float-end">
          <button mat-stroked-button class="bg-theme" (click)="exportData()">
            <i class="mi mi-save-alt small-icon mb-2"></i
            ><span translate class="translate"
              >pages.newRetailer.download</span
            >
          </button>
        </li>
      </ul>

    </div>
    
    <hr class="mb-0" />
    <div class="realtime-transactions-grid-container">
      <ag-grid-angular
        style="width: 100%; height: 60vh"
        class="ag-theme-material"
        [rowHeight]="40"
        [enableFilter]="true"
        [enableSorting]="true"
        [enableColResize]="true"
        [rowSelection]="'single'"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
      >
      </ag-grid-angular>
    </div>
  </div>
</div>